import { useEffect } from 'react';
import AppModal from '@/components/common/AppModal';
import { SplashState } from '@/state/SplashState';
import { useDispatch } from '@/state/store';
import { fetchLesStatus } from '@/actions/metaActions';

interface SplashProps {
    handleWindowChange: (window: SplashState) => void;
}
export const Splash = ({ handleWindowChange }: SplashProps) => {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(fetchLesStatus())
            .unwrap()
            .catch(e => console.warn(e));
    }, [dispatch]);
    return (
        <AppModal
            show
            className="c-information-modal c-splash-info"
            title="Nyttig informasjon om Vegkart"
            onClose={() => handleWindowChange(SplashState.NONE)}
        >
            <section className="c-splash-main">
                <div className="c-splash-main__grid-container">
                    <div className="c-splash-main__grid-container-item">
                        <p>Informasjon om Vegkart og innholdet i Nasjonal vegdatabank.</p>
                        <a
                            target="_blank"
                            rel="noreferrer noopener"
                            href="https://www.nvdb.no/hent-og-se-data/vegkart/"
                        >
                            Les mer om Vegkart.
                        </a>
                    </div>
                    <div className="c-splash-main__grid-container-item">
                        <p>
                            Finn brukerveiledning, opplæringsvideoer, og webinar for
                            Vegkart
                            <a
                                target="_blank"
                                rel="noreferrer noopener"
                                href="https://www.nvdb.no/hent-og-se-data/vegkart/grunnleggende-brukerveiledning/"
                            >
                                {' '}
                                på nvdb.no.
                            </a>
                        </p>
                    </div>
                </div>
                <div className="c-splash-main__highlight">
                    <p>
                        Vegsystemreferansen er en rapporterings- og oppslagsnøkkel for
                        enkelt å vite hvor man er på vegen. For europa-, riks- og
                        fylkesveger, er denne unik på landsbasis. For kommunale, private
                        og skogsveger, er denne unik innenfor den enkelte kommune.
                    </p>
                    <div
                        className="o-img-systemreferanse c-splash-divider__roadsystemreference"
                        role="image"
                    />
                    <a
                        target="_blank"
                        rel="noreferrer noopener"
                        href="https://www.vegvesen.no/fag/teknologi/nasjonal-vegdatabank/vegreferansesystem/"
                    >
                        Mer informasjon om referansesystemet i Nasjonal vegdatabank.
                    </a>
                </div>
                <div className="c-splash-main__paragraph">
                    <p>
                        Datagrunnlaget oppdateres fortløpende i Vegkart. Behandlingstiden
                        for små og store endringer kan ta alt fra sekunder til timer.
                    </p>
                    &nbsp;
                    <p>
                        Alle data er fritt tilgjengelig etter Norsk lisens for offentlige
                        data.
                    </p>
                    <p>
                        Stedsnavn hentes fra{' '}
                        <a
                            href="https://www.kartverket.no/"
                            target="_blank"
                            rel="noreferrer"
                        >
                            Sentralt stedsnavnregister (SSR) ©Kartverket
                        </a>
                        .
                    </p>
                </div>
            </section>
            <footer className="c-splash-footer">
                <hr />
                <div className="c-splash-footer-interactive">
                    <div className="c-splash-footer-link-container">
                        <a
                            className="c-splash-footer-interactive__item"
                            target="_blank"
                            rel="noreferrer noopener"
                            href="https://www.vegvesen.no/fag/teknologi/nasjonal-vegdatabank/kontakt-nvdb/"
                        >
                            Kontakt oss
                        </a>
                    </div>

                    <div className="c-splash-footer-link-container">
                        <button
                            type="button"
                            className="c-splash-footer-interactive__item"
                            title="Endringslogg"
                            aria-label="Endringslogg"
                            onClick={() => handleWindowChange(SplashState.CHANGELOG)}
                        >
                            Endringslogg
                        </button>
                    </div>

                    <div className="c-splash-footer-link-container">
                        <button
                            type="button"
                            className="c-splash-footer-interactive__item"
                            title="Personvernerklæring"
                            aria-label="Personvernerklæring"
                            onClick={() => handleWindowChange(SplashState.POLICY)}
                        >
                            Personvernerklæring
                        </button>
                    </div>

                    <div className="c-splash-footer-link-container">
                        <a
                            className="c-splash-footer-interactive__item"
                            target="_blank"
                            rel="noreferrer noopener"
                            href="https://uustatus.no/nb/erklaringer/publisert/abcf2dfc-797f-4774-a5e4-511a3b5a4aed"
                        >
                            Tilgjengelighetserklæring
                        </a>
                    </div>
                </div>
            </footer>
        </AppModal>
    );
};
